export default __webpack_public_path__ + "static/media/PSPv2.9ee92c25.png";